import { render, staticRenderFns } from "./TicketPayConfirm.vue?vue&type=template&id=096caace&scoped=true"
import script from "./TicketPayConfirm.vue?vue&type=script&lang=js"
export * from "./TicketPayConfirm.vue?vue&type=script&lang=js"
import style0 from "./TicketPayConfirm.vue?vue&type=style&index=0&id=096caace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096caace",
  null
  
)

export default component.exports